<template>
  <EntrySubmissionComponent
    :year="year"
    :submission-entry-form="submissionData"
    :submission-id="submissionId"></EntrySubmissionComponent>
</template>
<script setup lang="ts">
import EntrySubmissionComponent from '@/components/entry/EntrySubmissionComponent.vue';
import { ITeamDTO, YearDTO } from '@/dtos';
import { useSnack } from '@/helpers';
import { useSubmissionnStore, useYearStore } from '@/stores';
import { useAdminRegistrationStore } from '@/stores/modules/admin';
import { SNACKSTATUS } from '@/stores/util';
import { computed, ref } from 'vue';

const emit = defineEmits<{
  (e: 'snack', objType: string, snackType: SNACKSTATUS, err?: string): void;
}>();
const { throwSnack } = useSnack(emit);
interface Props {
  teamId: string;
  yearId: string;
  team: ITeamDTO;
}
const props = defineProps<Props>();
const teamId = ref<string>(props.teamId);
const yearId = ref<string>(props.yearId);
const submissionStore = useSubmissionnStore();
const registrationStore = useAdminRegistrationStore();
const yearStore = useYearStore();

const { data: registrationData } = registrationStore.getTeamRegistration(yearId, teamId);
const { data: yearData } = yearStore.getYearByIdQuery(yearId);

const submissionId = computed(() => registrationData.value?.id ?? '');
const year = computed(() => yearData.value ?? new YearDTO());

const { data: submissionData } = submissionStore.getSubmissionEntryQuery(submissionId);
</script>
